const PREFIX = 'accessories';

export const SPARTAN_PRODUCT_ACCESSORIES_TRACKING = {
  section: PREFIX,
  header: `${PREFIX}-header`,
  title: `${PREFIX}-title`,
  description: `${PREFIX}-description`,
  cardList: `${PREFIX}-card-list`,
  card: (index: number) => `${PREFIX}-card-${index + 1}`,
  cardTitle: (index: number) => `${PREFIX}-card-${index + 1}-title`,
  cardEyebrow: (index: number) => `${PREFIX}-card-${index + 1}-eyebrow`,
  cardImage: (index: number) => `${PREFIX}-card-${index + 1}-image`,
  remark: `${PREFIX}-remark`,
  remarkButton: `${PREFIX}-remark-button`,
  remarkModal: `${PREFIX}-remark-modal`,
  remarkModalPanel: `${PREFIX}-remark-panel`,
  remarkModalHeader: `${PREFIX}-remark-header`,
  remarkModalTitle: `${PREFIX}-remark-title`,
  remarkModalClose: `${PREFIX}-remark-close`,
  remarkModalContent: `${PREFIX}-remark-content`,
} as const;

export const SPARTAN_PRODUCT_ACCESSORIES_DATA_GA = {
  section: PREFIX,
  closeBackdrop: 'close_term_condition_backdrop',
} as const;
